import { useQuery } from '@apollo/client';
import { EXTENSION_INSTALLED_LIST } from '../api/graphql';
import Loader from '@appmaker/components/Loading';
import { useParams } from '@appmaker/core/routes';
import {
	CubeIcon,
	ExternalLinkIcon,
} from '@heroicons/react/outline';
import ListItem from '../components/ListItem';
import useRouterPath from '@appmaker/core/hooks/useRouterPath';
import useExtensionStore from '../store/list';
import { useEffect } from 'react';
import { Link } from '@appmaker/core/routes';
import RedirectV3 from './RedirectV3';

const Extensions = () => {
	const { handle, projectId } = useParams();
	const setExtensionData = useExtensionStore((state) => state.setExtensionData);
	const installedData = useExtensionStore((state) => state.installList);
	const { data, loading, error } = useQuery(EXTENSION_INSTALLED_LIST, {
		context: {
			headers: {
				'x-appmaker-project-id': projectId,
			},
		},
		fetchPolicy: 'no-cache',
		variables: {
			where: {
				project: {
					remoteProjectId: {
						equals: parseInt(projectId, 10),
					},
				},
			},
		},
	});
	const getRouterPath = useRouterPath();
	useEffect(() => {
		if (data) {
			setExtensionData(data.extensionInstalls);
		}
	}, [data]);
	if (loading) {
		return <Loader />;
	}
	return (
		<div className="bg-gray-50 h-screen overflow-y-auto">
			<RedirectV3 />
			<div className="max-w-2xl  mx-auto py-8 px-4 sm:py-8 sm:px-6 lg:max-w-5xl lg:px-8">
				<div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-y-6 lg:grid-cols-2">
					{installedData?.length === 0 ? (
						<div className="px-4 py-8 col-span-2 group rounded-xl bg-white bg-opacity-50 flex flex-col justify-center items-center border border-dashed border-gray-300">
							<CubeIcon className="h-16 w-16 p-4 bg-gray-200 rounded-full" />
							<h3 className="text-md font-medium text-gray-500 mt-3">
								No Extensions Installed
							</h3>
							{/* <a
								href="https://appmaker.xyz/extensions"
								target="_blank"
								rel="noreferrer"
								className="flex items-center text-indigo-500 hover:text-indigo-400 mt-2 text-sm font-medium"
							>

							</a> */}
							<Link to={getRouterPath('/extension-list')}
								className="flex items-center text-indigo-500 hover:text-indigo-400 mt-2 text-sm font-medium"
							>
								<span> Explore Extensions</span>{' '}
								<ExternalLinkIcon className="h-4 w-4 inline-block ml-1" />
							</Link>
						</div>
					) : (
						installedData?.map((extension) => (
							<ListItem
								key={extension.id}
								extension={extension.extension}
								getRouterPath={getRouterPath}
							/>
						))
					)}
				</div>
			</div>
		</div>
	);
};

export default Extensions;
